import { render, staticRenderFns } from "./PaperSync.vue?vue&type=template&id=8b41fc9e&scoped=true&"
import script from "./PaperSync.vue?vue&type=script&lang=js&"
export * from "./PaperSync.vue?vue&type=script&lang=js&"
import style0 from "./PaperSync.vue?vue&type=style&index=0&id=8b41fc9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b41fc9e",
  null
  
)

export default component.exports